import type {AppConfigQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Device 도메인 Query Key 관리
 */
export const DEVICE_QUERY_KEY_MAP = {
  /**
   * 앱 설정 조회
   * Origin: useAppConfigQuery.getKey
   */
  appConfig: (variables?: AppConfigQueryVariables) =>
    variables === undefined
      ? [ADAPTER_QUERY_KEY_PREFIX, 'appConfig']
      : [ADAPTER_QUERY_KEY_PREFIX, 'appConfig', variables],
  /**
   * 디바이스 정보 조회
   * Origin: useDeviceInfoQuery (getKey 없음)
   */
  deviceInfo: [ADAPTER_QUERY_KEY_PREFIX, 'deviceInfo'],
} as const;

/**
 * Device 도메인 Mutation Key 관리
 */
export const DEVICE_MUTATION_KEY_MAP = {
  /**
   * 기기 추가
   * Origin: useAddDeviceMutation (getKey 없음)
   */
  addDevice: 'addDevice',
  /**
   * 디바이스 삭제
   * Origin: useDeleteDeviceMutation (getKey 없음)
   */
  deleteDevice: 'deleteDevice',
} as const;
